export default {
  API_ENDPOINT: 'https://intense-lowlands-42230.herokuapp.com/'
}